(function () {

    'use strict';

    angular.module('iplusjs.adresseValidator', [
        'lodash',
        'iplusjs.utils.adresse',
        'iplusjs.utils.formField',
        'iplusjs.utils.schluesselWerte',
        'iplusjs.utils.misc',
        'iplusjs.loadingIndicator'
    ])
        .directive('iplusjsAdresseValidator', adresseValidator);

    AdresseValidatorController.$inject = [
        'lodash',
        'AdresseUtilsService',
        'MiscUtilsService'
    ];
    function AdresseValidatorController(_, AdresseUtilsService, MiscUtilsService) {
        var vm = this;

        vm.adresse = {};
        vm.checkType = 'OK';
        vm.vorschlaege = [];
        vm.isValid = true;

        vm.hasVorschlaege = hasVorschlaege;
        vm.setCheckedAdresse = setCheckedAdresse;
        vm.setValidState = setValidState;
        vm.resetCheckedAdresse = resetCheckedAdresse;
        function hasVorschlaege() {
            return !!vm.vorschlaege.length;
        }
        function resetCheckedAdresse() {
            vm.adresse = {};
            vm.checkType = 'OK';
            vm.vorschlaege = [];
            vm.isValid = true;
        }
        function setCheckedAdresse(origAdresse, checkedAdresse) {
            checkedAdresse = checkedAdresse || {
                result: AdresseUtilsService.resultTypes.FEHLER
            };

            vm.vorschlaege = _highlightChanges(_bereinigeVorschlage(origAdresse, AdresseUtilsService.getVorschlaege(checkedAdresse)), origAdresse) || [];
            vm.checkType = checkedAdresse.result;
            vm.adresse = origAdresse;

            if (_.includes([AdresseUtilsService.resultTypes.OK], vm.checkType)) {
                vm.uebernehmeAdresse(checkedAdresse.adresse);
            }
        }
        function setValidState(checkedAdresse) {
            checkedAdresse = checkedAdresse || {
                result: AdresseUtilsService.resultTypes.FEHLER
            };

            vm.checkType = checkedAdresse.result;

            if (_.includes([AdresseUtilsService.resultTypes.OK], vm.checkType)) {
                vm.isValid = true;
            } else {
                vm.isValid = false;
            }
        }
        function _bereinigeVorschlage(origAdresse, vorschlaege) {
            _.forEach(vorschlaege, function (vorschlag, index) {
                _.forOwn(origAdresse, function (value, prop) {
                    var validationItem = vm.getValidationItem(vm.validationItems, prop);
                    if (!_.isEqual(value, vorschlag[prop]) && (!!_.get(validationItem, '$attrs.disabled', false) || !!_.get(validationItem, '$attrs.readonly', false))) {
                        _.remove(vorschlaege, vorschlag);
                    }
                    if (MiscUtilsService.isEmpty(_.trim(vorschlag[prop]))) {
                        _.remove(vorschlaege, vorschlag);
                    }
                });
            });

            return vorschlaege;
        }

        function _highlightChanges(vorschlaege, origAdresse) {
            _.forEach(vorschlaege, function (vorschlag, index) {
                var changedProps = [];
                _.forOwn(origAdresse, function (value, prop) {
                    if (value !== vorschlag[prop] && prop !== 'land') {
                        changedProps.push(prop);
                    } else if (_.get(value, 'wert') !== _.get(vorschlag[prop], 'wert') && prop === 'land') {
                        changedProps.push(prop);
                    }
                });

                vorschlag.changedProps = changedProps;
            });

            return vorschlaege;
        }
    }

    adresseValidator.$inject = [
        '$log',
        '$timeout',
        'lodash',
        '$q',
        'AdresseUtilsService',
        'SchluesselWerteUtilsService',
        'MiscUtilsService',
        'FormFieldUtilsService',
        'LoadingIndicatorService'
    ];
    function adresseValidator($log, $timeout, _, $q, AdresseUtilsService, SchluesselWerteUtilsService, MiscUtilsService, FormFieldUtilsService, LoadingIndicatorService) {
        return {
            restrict: 'A',
            require: ['ngModel', '?iplusjsValidatorGroup', '^?iplusjsFieldset'],
            scope: {
                onChange: '&avOnChange',
                onValidate: '&avOnValidate',
                options: '<avOptions'
            },
            templateUrl: 'common/adresse/adresseValidator.html',
            link: linkFnc,
            controller: AdresseValidatorController,
            controllerAs: 'adrValidatorVm',
            bindToController: true,
            transclude: true
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            $timeout(function () {
                var $ngModel = ctrls[0],
                    validatorGroupCtrl = ctrls[1],
                    fieldsetCtrl = ctrls[2],
                    ctrlScope = $scope.adrValidatorVm,
                    validationItems = validatorGroupCtrl && validatorGroupCtrl.getItems();

                if (!validationItems.length || (fieldsetCtrl && fieldsetCtrl.disabled)) {
                    return;
                }

                ctrlScope.options = ctrlScope.options || {};
                ctrlScope.id = ctrlScope.options.id || 'adresseValidatorError';
                ctrlScope.validationItems = validationItems;
                ctrlScope.uebernehmeAdresse = uebernehmeAdresse;
                ctrlScope.getValidationItem = getValidationItem;
                validationItems[0].$scope.$watchGroup(MiscUtilsService.getValuesByProperty(validationItems, '$attrs.ngModel'), function (value) {
                    var adresse = _getAdresse(value, validationItems);

                    if (AdresseUtilsService.isAdresseVollstaendig(adresse, ctrlScope.options.ignoreLand)) {
                        $ngModel.$validate();
                    } else {
                        ctrlScope.resetCheckedAdresse();
                    }
                });
                $ngModel.$asyncValidators.adresse = function (value) {
                    var adresse = _getAdresse(value, validationItems),
                        loadingIndicatorPromise,
                        uuid = MiscUtilsService.guid;

                    if (!AdresseUtilsService.isAdresseVollstaendig(adresse) || MiscUtilsService.isNotEmpty(_.get($ngModel, '$pending.adresse'))) {
                        ctrlScope.onValidate();
                        return $q.resolve();
                    }

                    loadingIndicatorPromise = LoadingIndicatorService.addInProgress(uuid, { timeout: 300 });

                    return AdresseUtilsService.checkAdresse(adresse).then(function (checkedAdresse) {
                        $log.debug('adresseValidator $asyncValidators.adresse SUCCESS', checkedAdresse);
                        ctrlScope.setValidState(checkedAdresse);
                        FormFieldUtilsService.setValidity(validationItems, 'adresse', ctrlScope.isValid);
                        ctrlScope.onValidate();
                        ctrlScope.setCheckedAdresse(adresse, checkedAdresse);

                        return true;
                    }).catch(function (error) {
                        $log.debug('adresseValidator $asyncValidators.adresse FAILURE', error);
                        ctrlScope.setValidState(null);
                        FormFieldUtilsService.setValidity(validationItems, 'adresse', ctrlScope.isValid);
                        ctrlScope.onValidate();
                        ctrlScope.setCheckedAdresse(adresse, null);

                        return $q.reject();
                    }).finally(function () {
                        LoadingIndicatorService.removeInProgress(uuid, loadingIndicatorPromise);
                    });
                };
                function _getAdresse(value, validationItems) {
                    var adresse = {
                        land: SchluesselWerteUtilsService.create('LAND', 'D', 'Deutschland')
                    };

                    if (!_.includes(MiscUtilsService.getValuesByProperty(validationItems, 'modelPropName'), 'land')) {
                        return _.merge(adresse, MiscUtilsService.getValuesAsObject(value, MiscUtilsService.getValuesByProperty(validationItems, 'modelPropName')));
                    } else {
                        return _.merge({}, MiscUtilsService.getValuesAsObject(value, MiscUtilsService.getValuesByProperty(validationItems, 'modelPropName')));
                    }
                }
                function uebernehmeAdresse(vorschlag) {
                    if (!ctrlScope.options.ngModelChangeManually) {
                        _.each(validationItems, function (item) {
                            item.$ngModel.$setViewValue(vorschlag[item.modelPropName]);
                            item.$ngModel.$commitViewValue();
                            item.$ngModel.$render();
                        });
                    }

                    delete vorschlag.changedProps;

                    FormFieldUtilsService.setValidity(validationItems, 'adresse', true);

                    ctrlScope.onChange({
                        adresse: vorschlag,
                        checkType: ctrlScope.checkType,
                        validationItems: validationItems
                    });

                    ctrlScope.resetCheckedAdresse();
                }
                function getValidationItem(validationItems, name) {
                    return _.filter(validationItems, {
                        modelPropName: name
                    })[0];
                }
            });
        }
    }
})();
